module.exports = __webpack_public_path__ + "img/05010006.a9c598fa.jpg";